import * as React from 'react';
import { DashboardFavouriteLayout } from 'app/area/dashboard/types-store';
import { DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import styles from './dashboard-cell.scss';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { Favourite } from 'app/area/favourite/favourite';
import { FavouriteInstance } from 'app/area/favourite/favourite-context';
import { dashboardLayoutTypeContext } from 'app/area/dashboard/constants';
import { ReportCommonApi } from 'app/area/reports/types-api';

interface DashboardCellProps {
  reportApiOverrides: Partial<ReportCommonApi>;
  executionCounter: number;
  favouriteModel: DashboardFavouriteLayout;
  containerWidth: number;
  drillDown: DrillDownCallback;
  requestCustomWidth: (id: number, val: any) => void;
}

export const DashboardCell = ({
  reportApiOverrides,
  executionCounter,
  favouriteModel,
  containerWidth,
  drillDown,
  requestCustomWidth
}: DashboardCellProps) => {

  const containerStyle = {
    width: containerWidth > 0 ?
      `${containerWidth}%` :
      '0'
  };

  return (
    <div className={styles.cell} style={containerStyle}>
      <div className={styles.wrapper}>
        <Link to={routeConstants.favouriteFor(favouriteModel.favourite)}>
          <h3 className={styles.header}>
            {favouriteModel.description}
          </h3>
        </Link>
        <FavouriteInstance
          hideFilters={true}
          hideHeader={true}
          hideVisualizationOptions={true}
          reportApiOverrides={reportApiOverrides}
          executionCounter={executionCounter}
          layoutTypeContextId={dashboardLayoutTypeContext}
          height={favouriteModel.height}
        >
          <Favourite
            favouriteId={favouriteModel.favourite}
            overrideReport={favouriteModel.report}
            embeddedFavourite={true}
            statisticalReportExternalProps={{
              drillDown,
              requestCustomWidth
            }}
          />
        </FavouriteInstance>
      </div>
    </div>
  );
};
